module.exports = __webpack_public_path__ + "static/background-3e13209a15370345a3e58daf29e67ee9.jpg";